<template>
  <div
    key="builderImage"
    class="flex-1 builder-right overflow-hidden relative hidden md:block">
    <fade-transition>
      <img
        v-if="currentConfigurationStep && currentConfigurationStep.imageUrl"
        :src="currentConfigurationStep.imageUrl"
        :alt="currentConfigurationStep.step"
        class="block object-cover w-full h-full builder-img" />
      <div
        v-else-if="designStep"
        class="flex justify-center">
        <fade-transition>
          <img
            v-if="selectedDesign"
            :key="selectedDesign.image"
            class="block object-cover w-full h-full builder-img"
            :src="selectedDesign.image"
            alt="design" />
        </fade-transition>
        <div class="absolute bottom-6 text-center br-3 p-4 glass">
          <div v-if="selectedDesign && selectedDesign.colour_options.length">
            <p class="typeset-4">{{ t("book-builder.more-colours") }}</p>
            <ul class="flex list-unstyled mt-3 justify-center">
              <li
                v-for="option in selectedDesign.colour_options"
                :key="option"
                :style="{ backgroundColor: `#${option.hex_code}` }"
                class="colour-option h-5 w-5 br-circle mx-2 mb-4 cursor-pointer"
                :class="{
                  border: selectedDesign.analytics_id === option.analytics_id
                }"
                @click="handleColourOptionClick(option)"></li>
            </ul>
          </div>
          <a
            class="underline"
            target="_blank"
            href="#"
            @click.prevent="findOutMore">
            {{ t("book-builder.find-out-more") }}
          </a>
        </div>
      </div>
    </fade-transition>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import FadeTransition from "@/app/javascript/components/transitions/FadeTransition.vue";

export default {
  name: "BuilderImage",
  components: {
    FadeTransition
  },
  computed: {
    ...mapState({
      bookType: state => state.bookType,
      pageType: state => state.pageType,
      coverType: state => state.coverType,
      sizeType: state => state.sizeType,
      formatType: state => state.formatType,
      selectedDesign: state => state.selectedDesign
    }),
    configurationSteps() {
      return [
        {
          step: "book-type",
          imageUrl: this.bookType?.imageUrl
        },
        {
          step: "page-type",
          imageUrl: this.pageType?.imageUrl
        },
        {
          step: "cover-type",
          imageUrl: this.coverTypeImage
        },
        {
          step: "size-type",
          imageUrl: this.sizeTypeImage
        },
        {
          step: "format-type",
          imageUrl: this.formatType?.imageUrl
        }
      ];
    },
    currentConfigurationStep() {
      return this.configurationSteps.find(step =>
        this.$route.fullPath.includes(step.step)
      );
    },
    designStep() {
      return this.$route.fullPath.includes("design");
    },
    findOutMorePath() {
      return `${window.countryCode}/${this.selectedDesign.slug}`;
    },
    coverTypeImage() {
      if (!this.bookType || !this.coverType) return null;
      switch (this.bookType.categoryId) {
        case 763:
          return this.coverType.midYearDiaryImageUrl;
        case 805:
          return this.coverType.academicDiaryImageUrl;
        case 815:
          return this.coverType.recipeImageUrl;
        default:
          return this.coverType.notebookImageUrl;
      }
    },
    sizeTypeImage() {
      if (!this.bookType || !this.sizeType) return null; // Early return if null

      switch (this.bookType.categoryId) {
        case 73:
          return this.sizeType.notebookImageUrl;
        default:
          return this.sizeType.diaryImageUrl;
      }
    }
  },
  methods: {
    ...mapActions(["replaceDesignWithOption"]),
    ...mapMutations(["setSelectedDesign"]),
    selectDesign(design) {
      analytics.track("Gift Builder Selected Design", {
        analytics_id: design.analytics_id
      });
      this.setSelectedDesign(design);
    },
    handleColourOptionClick(option) {
      const updatedDesign = {
        ...this.selectedDesign,
        ...option
      };
      this.selectDesign(updatedDesign);
    },
    findOutMore() {
      if (!this.selectedDesign) return;

      analytics.track("Gift Builder - Clicked Find out more", {
        id: this.selectedDesign.analytics_id
      });
      window.open(this.findOutMorePath, "_blank");
    }
  }
};
</script>

<style lang="scss" scoped>
.builder-right {
  grid-column: 3/-1;
}

.builder-img {
  width: 100%;
  display: block;
  position: absolute;
  left: 0;
}
</style>
